<template>
  <div
    v-if="user && user.profile"
    class="user-panel"
    data-qa="user-panel">
    <sBadge
      v-if="$acl.check('onlyTenders')"
      class="user-panel-yk"
      color="red"
      content="new"
      inner-styles="padding: 1px 3px; height: 14px;"
      offset-x="-5"
      offset-y="10"
      rounded="false"
      :value="showBadge">
      <div
        class="flex pointer hover-5"
        @click="gotoYKMarket">
        <sIcon
          class="mr-2 my-auto"
          type="yc"/>
        <div class="text-left">
          {{ $t('yk_line1') }}<br>{{ $t('yk_line2') }}
        </div>
      </div>
    </sBadge>
    <NotificationsBell class="mr-2"/>
    <sPopover
      v-model="menu"
      placement="bottom-end"
      popper-class="user-panel__menu"
      trigger="click"
      @show="openMenu">
      <div
        slot="reference"
        class="user-panel__user-btn">
        <div class="user-panel__user-btn-label">
          <div data-qa="profile-name">
            {{ user.profile.name }}
          </div>
          <div
            class="h8-text grey--text"
            data-qa="current-organization-title"
            style="max-width: 280px; overflow: hidden; white-space: nowrap;">
            <TooltipedText
              ref="TooltipedText"
              :max-length="35"
              :value="currentOrganization ? currentOrganization.title : ''"/>
          </div>
        </div>
        <UserIcon
          border-color="var(--black-color)"
          :class="{'is-admin': mixin_isGodMode}"
          :data-content="mixin_isGodMode ? $t('Common.Admin') : ''"
          data-qa="user-icon"
          :name="user.profile.name"
          size="30"
          :src="user.profile.picture"/>
      </div>
      <div>
        <div class="px-3 pt-2 flex flex-wrap align-center">
          <UserIcon
            border-color="var(--black-color)"
            :class="{'is-admin': mixin_isGodMode}"
            :data-content="mixin_isGodMode ? $t('Common.Admin') : ''"
            :name="user.profile.name"
            size="32"
            :src="user.profile.picture"/>
          <div class="ml-2">
            <div
              class="h7-text-medium text-start"
              data-qa="profile-name">
              {{ user.profile.name }}
            </div>
            <div
              class="h8-text-medium secondary__green_not_active--text text-start"
              data-qa="profile-preferred-username">
              {{ user.profile.preferred_username | lower }}
            </div>
          </div>
        </div>
        <div>
          <OrgsList
            v-if="showObjectsCombo"
            class="mx-4"
            data-qa="select-organization"
            :model.sync="organization"
            :multiple="false"
            transparent
            @blur="blurOrgs"
            @change="changeOrg"/>
          <span
            v-else-if="currentOrganization"
            class="px-5 h7-text-medium black--text">
            <TooltipedText
              ref="TooltipedText"
              :max-length="29"
              :value="org_title"/>
          </span>
        </div>
        <div>
          <MenuItem
            v-if="needSnow"
            class="h7-text-medium"
            icon-color="grey"
            label="Сніг"
            @click="changeSnow">
            <div
              slot="content"
              style=" display: grid; grid-template-columns: 30px 1fr;">
              <div style="font-size: 19px;">
                ❄
              </div>
              <div class="my-auto">
                Сніг
              </div>
            </div>
          </MenuItem>
          <ThemeButton/>
          <MenuItemCollapse
            ref="menuAdmin"
            data-qa="admin"
            :flyout="growthBook.userPanelMenuFlyout"
            icon="category"
            :icon-color="mixin_isGodMode ? 'var(--alert-success-icon)' : null"
            :label="$t('Menu.Administration')">
            <div slot="submenu">
              <div class="py-2 px-4">
                <div>{{ `${$t('Common.Version1')}:` }}<b class="ml-1">{{ version }}</b></div>
                <div>{{ `${$t('Common.Collection')}:` }}<b class="ml-1">{{ buildVersion }}</b></div>
              </div>
              <sDivider class="my-1"/>
              <template v-if="$acl.check('isGoodMode')">
                <MenuItem
                  class="h7-text-medium"
                  data-qa="godMode"
                  :icon="mixin_isGodMode ? 'accept' : 'cancel'"
                  :icon-color="mixin_isGodMode ? 'var(--alert-success-icon)' : 'grey'"
                  :label="$t('Common.Admin')"
                  @click="changeGoodMode(!mixin_isGodMode)"/>
                <MenuItem
                  v-if="mixin_isGodMode"
                  class="h7-text-medium"
                  data-qa="copyToken"
                  icon="copy"
                  icon-color="grey"
                  :label="$t('Common.token')"
                  @click="copyToken"/>
                <MenuItem
                  class="h7-text-medium"
                  data-qa="href-saved-settings"
                  :disabled="$acl.not.check('isPublic')"
                  icon="setting"
                  icon-color="grey"
                  :label="$t('Menu.SavedSettings')"
                  :to="{ name:'saved-settings'}"
                  @click="menu = false"/>
                <MenuItem
                  class="h7-text-medium"
                  data-qa="href-settings"
                  :disabled="$acl.not.check('tendersView')"
                  icon="setting"
                  icon-color="grey"
                  :label="$t('Menu.OrganizerSettings')"
                  :to="{ name:'organizerSettings'}"
                  @click="menu = false"/>
                <MenuItem
                  class="h7-text-medium"
                  data-qa="href-events-stat"
                  :disabled="$acl.not.check('tenderAdmin')"
                  icon="circle-start"
                  icon-color="grey"
                  :label="$t('Menu.EventLog')"
                  :to="{ name:'page-events-stat'}"
                  @click="menu = false"/>
                <MenuItem
                  class="h7-text-medium"
                  data-qa="href-automation-events"
                  :disabled="$acl.not.check('tenderAdmin')"
                  icon="circle-start"
                  icon-color="grey"
                  :label="$t('Menu.AutomationEvents')"
                  :to="{ name:'page-automation-events'}"
                  @click="menu = false"/>
                <MenuItem
                  class="h7-text-medium"
                  data-qa="ip-filters"
                  :disabled="$acl.not.check('tendersView')"
                  icon="setting"
                  icon-color="grey"
                  :label="$t('Menu.IpFilters')"
                  :to="{ name:'ipFilters'}"
                  @click="menu = false"/>
                <MenuItem
                  v-if="mixin_isGodMode && growthBook.growthbookFeaturesPage && $_hasGrowthbookFeaturesRole"
                  class="h7-text-medium"
                  data-qa="growthbook-features"
                  icon="setting"
                  icon-color="grey"
                  :label="$t('Menu.GrowthbookFeatures')"
                  :to="{ name:'growthbookFeatures'}"
                  @click="menu = false"/>
                <sDivider class="my-1"/>
              </template>
              <MenuItem
                class="h7-text-medium"
                data-qa="menu-editProfile"
                icon="edit"
                icon-color="grey"
                :label="$t('User.EditProfile')"
                @click="editProfile"/>
              <MenuItem
                v-if="$acl.check('tenderAdmin')"
                class="h7-text-medium"
                data-qa="href-user-management"
                :href="pageProps.user_manager_link"
                icon="person"
                icon-color="grey"
                :label="$t('User.UserManagement')"
                target="_blank"
                @click="menu = false"/>
              <MenuItem
                class="h7-text-medium"
                data-qa="href-company-profile"
                :disabled="$acl.check('noAccess')"
                :href="pageProps.company_link"
                icon="work"
                icon-color="grey"
                :label="$t('User.CompanyProfile')"
                target="_blank"
                @click="menu = false"/>
            </div>
          </MenuItemCollapse>
          <MenuItem
            class="h7-text-medium"
            data-qa="balance"
            icon="money"
            icon-color="grey"
            :label="$t('User.Balance')"
            text
            @click="menu = false">
            <span
              slot="after"
              :class=" (settings && settings.balance > 0 ? 'secondary__green_approved_darken' : 'secondary__red') + '--text ml-1' "
              data-qa="balance">
              {{ formSum(settings ? settings.balance : 0) }} {{ settings && settings.currency ? settings.currency.shortTitle : $t('Tenders.hrn') }}
            </span>
          </MenuItem>
          <CreateInvoiceDialog
            data-qa="user-panel-create-invoice"
            mode="list"
            @close="menu = false"/>
          <MenuItem
            class="h7-text-medium"
            data-qa="href-completed-work-acts"
            :disabled="$acl.check('noAccess')"
            :href="pageProps.mysigny_link + 'folder/incoming;smarttender'"
            icon="draft"
            icon-color="grey"
            :label="$t('User.CompletedWorkActs')"
            target="_blank"
            @click="menu = false"/>
          <MenuItem
            class="h7-text-medium"
            data-qa="language-items"
            icon="world"
            icon-color="grey"
            text>
            <IconLanguageComponent slot="content"/>
          </MenuItem>
          <sDivider/>
          <MenuItem
            class="h7-text-medium"
            data-qa="href-new-improvements"
            :disabled="$acl.check('noAccess')"
            icon="category"
            icon-color="grey"
            :label="$t('User.NewImprovements')"
            :to="{ name:'releases'}"
            @click="menu = false"/>
          <MenuItemCollapse
            data-qa="instruction"
            :disabled="instructions.needLoading || (instructions && instructions.values && !instructions.values.length)"
            :flyout="growthBook.userPanelMenuFlyout"
            :icon="instructions.load || instructions.needLoading ? 'loading' : 'question'"
            :label="$t('User.Instructions')">
            <div slot="submenu">
              <MenuItem
                v-for="(instruction, n) in instructions.values"
                :key="`instruction-${n}`"
                class="h7-text-medium text-left my-1"
                :data-qa="`instruction-${n}`"
                height="inherit"
                icon="download"
                icon-color="grey"
                :label="instruction.name"
                @click="downloadInstruction(instruction.id, instruction.name)"/>
            </div>
          </MenuItemCollapse>
          <sDivider/>
          <MenuItem
            class="h7-text-medium"
            data-qa="logout"
            icon="exit"
            icon-color="grey"
            :label="$t('User.Exit')"
            @click="logout"/>
        </div>
      </div>
    </sPopover>
  </div>
</template>
<script>
import { eventBus } from '@/main'
import UserIcon from 'components/header/UserIcon.vue'
import MenuItem from 'components/common/MenuItem.vue'
import OrgsList from 'components/common/elements/OrgsList.vue'
import MenuItemCollapse from 'components/common/MenuItemCollapse.vue'
import NotificationsBell from 'components/header/NotificationsBell.vue'
import CreateInvoiceDialog from 'components/billing/CreateInvoiceDialog.vue'
import IconLanguageComponent from 'components/header/IconLanguageComponent.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import ThemeButton from 'components/common/ThemeButton.vue'

import axios from 'axios'
import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()

import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()
import { mapGetters } from 'vuex'
import { modalMixin, userMixin } from 'mixins'
import tour from 'mixins/tour'
import godModeMixin from 'mixins/godModeMixin'
import growthbookFeaturesAccessMixin from 'mixins/growthbookFeaturesAccessMixin'

/**
 * Главное меню пользователя
 * @vue-data {Array} instructions.needLoading - Инструкции еще не загружались
 * @vue-data {Array} instructions.values - Инструкции
 * @vue-data {Boolean} instructions.load - Признак загрузки инструкции
 */
export default {
  name: 'userPanel',
  mixins: [ tour, userMixin, modalMixin, godModeMixin, growthbookFeaturesAccessMixin],
  data() {
    return {
      needSnow: false,
      showBadge: new Date() < new Date('2023-12-01T00:00:00'),
      pageProps: {
        company_link: null,
        mysigny_link: null,
        user_manager_link: null,
      },
      userMenuBtnStyle: [
        { 'textTransform': 'none' },
        { 'font-weight': 300 },
        { color: 'rgb(102, 102, 102)' },
        { 'border-color': '#c6c6c6' }
      ],
      currentOrganization: null,
      organization: null,
      user: {},
      instructions: {
        needLoading: true,
        values: [],
        load: false,
      },
    }
  },
  filters: {
    lower(val) {
      return val.toLowerCase()
    }
  },
  async created() {
    const date = new Date()
    this.needSnow = (date.getMonth() === 11 && date.getDate() >= 15 || date.getMonth() === 0 && date.getDate() <= 15)
    this.user = this.user && Object.keys(this.user).length ? this.user : await this.$auth.getUser()
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      sprAvailableOrganizations: 'getAvailableOrganizations',
      storedCurrentOrganization: 'getCurrentOrganization',
    }),
    version: {
      get() {
        return window.config.Version
      }
    },
    buildVersion: {
      get() {
        return window.config.BuildVersion
      }
    },
    menu: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    },
    availableOrganizations() {
      if (this.sprAvailableOrganizations?.length === 0) {
        return []
      }
      return this.sprAvailableOrganizations.map((org) => ({
        current: this.storedCurrentOrganization ? org.organizationItId === this.storedCurrentOrganization.organizationItId : org.isDefault,
        isDefault: org.isDefault,
        organizationItId: org.organizationItId,
        okpo: org.oKPO,
        title: org.title//  this.getOrgTitle(org)
      }))
    },
    org_title() {
      let short = this.currentOrganization?.shortTile,
        title =  this.currentOrganization?.title
      return (short || title) ? (short || title) : ''
    },
    showObjectsCombo() {
      return this.sprAvailableOrganizations && this.sprAvailableOrganizations.length > 1
    },
  },
  methods: {
    openMenu() {
      if (this.instructions.needLoading) {
        this.$store.dispatch('getInstructions')
          .then(res => {
            this.instructions.values = res
          })
          .finally(() => {
            this.instructions.needLoading = false
          })
      }
    },
    changeSnow() {
      this.$root.$emit('changeSnow')
    },
    gotoYKMarket() {
      api.saveEvent('REDIRECT_TO_YK_MARKET')
        .then(() => {
          this.$router.push({name: 'newTender', query: {flou: 'youcontrol'}})
        })
    },
    async downloadInstruction(instructionId, title) {
      const url = `${window.config.GrapgQlUrl}/files/loadInstruction`
      this.instructions.load = true
      await axios.get(url,
        {
          params: {instructionId: instructionId},
          headers: await files_api.getHeaders(),
          responseType: 'blob'
        }
      )
        .then((response) => {
          let url = URL.createObjectURL(response.data)
          let a = document.createElement('a')
          a.setAttribute('href', url)
          a.setAttribute('download', title)
          a.click()
          this.menu = false
        })
        .finally(() => this.instructions.load = false)
    },
    async logout() {
      this.$store.commit('clearAvailableOrganizations')
      await this.$auth.signOut()
    },
    copyToken() {
      this.$auth.getUserToken()
        .then((result) => {
          navigator.clipboard.writeText(result.id_token || this.user.access_token)
          this.$notice.info({
            message: this.$t('Common.done'),
            duration: 2
          })
        })
    },
    editProfile() {
      this.menu = false
      window.open(window.config.SmartIdUrl + `/userprofile?returnUrl=${window.location.href}&client_id=s.smarttender.biz`)
    },
    async changeOrg(newOrg) {
      if (!newOrg) {
        newOrg = this.currentOrganization
        return
      }
      await this.changeOrganisation(newOrg, this.currentOrganization, true)
      this.currentOrganization = newOrg
      this.menu = false
    },
    blurOrgs() {
      if (!this.organization) {
        this.organization = this.currentOrganization
      }
    },
    createLinks() {
      this.pageProps.mysigny_link = this.$t('User.CompanyProfileLink',  { domen: window.config?.MySignyUrl })

      let companyAfterHref = ''
      let userManagerAfterHref = ''
      if (this.mixin_isGodMode) {
        if (this.currentOrganization.organizationId) {
          companyAfterHref = `${this.currentOrganization.organizationId}/`
          userManagerAfterHref = `edit/${this.currentOrganization.organizationId}/3/`
        }
      }
      this.pageProps.company_link = `${this.$t('User.CompanyProfileLink', { domen: window.config?.SmarttenderUrl })}${companyAfterHref}`
      this.pageProps.user_manager_link = `${window.config?.SmarttenderUrl}commercial/company-profile/organizer/${userManagerAfterHref}`
    }
  },
  watch: {
    storedCurrentOrganization: function(newOrg) {
      eventBus.$emit('organizationUpdate', newOrg)
      this.currentOrganization = newOrg
      this.createLinks()
    },
    '$route'() {
      if (this.$refs.menuAdmin) {
        this.$refs.menuAdmin.show = false
      }
      this.menu = false
    }
  },
  mounted() {
    this.currentOrganization = this.storedCurrentOrganization
    this.organization = this.storedCurrentOrganization
    this.createLinks()

    /*if (this.$acl.check('isGoodMode')) {
      this.$_getPropFromDBStorage('godMode_tour', false)
        .then(async (viewedTour) => {
          if (viewedTour) { return }
          const tour = [
            {
              dataKey: 'user-panel',
              title: this.$t('Common.adminMode'),
              text: 'Пам\'ятаєте тут був перемикач режима адміна?',
              step: 1,
              position: 'middle-right'
            },
            {
              dataKey: 'user-icon',
              title: this.$t('Common.adminMode'),
              text: `Тепер він переїхав сюди.</br>В пункт <b>${this.$t('Menu.Administration')}</b>`,
              step: 2,
              position: 'middle-right'
            }
          ]
          eventBus.$emit('startTour', tour)
          await this.$_savePropToDBStorage('godMode_tour', true)
        })
    }*/
  },
  components: {
    OrgsList,
    UserIcon,
    MenuItem,
    ThemeButton,
    TooltipedText,
    MenuItemCollapse,
    NotificationsBell,
    CreateInvoiceDialog,
    IconLanguageComponent
  },
  props: {
    visible: {
      type: Boolean
    }
  },
  i18n: {
    messages: {
      uk: {
        yk_line1: 'Списки постачальників',
        yk_line2: 'від YC Market',
      },
      en: {
        yk_line1: 'List of vendors',
        yk_line2: 'from YC.Market',
      },
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep.shadow {
  box-shadow: 1px 1px 4px -2px #ebeef5 !important;
  border-radius: 0 0 4px 4px;
}
.godMode-label {
  font-size: 10px;
  cursor: pointer;
  line-height: 1;
  margin-top: 5px;
}
.bottom-buttons {
  border: black 1px;
}
.header-btns .v-icon {
  color: #25282B
}
.user-panel {
  font-size: 14px;
  color: var(--text-color);
  font-weight: 500;
  min-width: max-content;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  &-yk {
    margin-right: 24px;
    @media (max-width: 390px) {
      display: none;
    }
  }
  &__user-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    &-label {
      margin-right: 8px;
      @media (max-width: 1175px) {
        display: none;
      }
    }
  }

}
.yk-market {
  @media (max-width: 475px) {
    display: none;
  }
}
.user-icon {
  overflow: hidden;
  position: relative;
  &.is-admin:before {
    content: attr(data-content);
    background: var(--color-error);
    line-height: 1;
    position: absolute;
    transform: rotate(45deg);
    left: 0px;
    top: 9px;
    right: 0;
    text-align: center;
    padding: 1px 0;
    font-size: 10px;
    border-radius: 4px;
    z-index: 1;
    white-space: nowrap;
  }
}
</style>
<style lang="scss">
.user-panel {
  &__menu {
    border: 2px solid var(--v-main__green-base)!important;
    background-color: var(--v-secondary__green_chosen-base)!important;
    border-radius: 0 0 4px 4px;
    width: 330px;
    @media (max-width: 410px) {
      width: 100% !important;
      left: 0 !important;
      right: 0 !important;
    }
  }
}
</style>
